import { all, fork } from 'redux-saga/effects';
import appSagas from 'src/redux/app/sagas';
import initDesignProSagas from 'src/redux/initDesignPro/sagas';
import jobDesignsSagas from 'src/redux/jobDesigns/sagas';
import jobShareSagas from 'src/redux/jobShare/sagas';
import keyboardEventsSagas from 'src/redux/keyboardEvents/sagas';
import macheteSagas from 'src/redux/machete/sagas';
import measureModeSagas from 'src/redux/measureMode/sagas';
import notificationSagas from 'src/redux/notification/sagas';
import splitSagas from 'src/redux/split/sagas';
import trackingSagas from 'src/redux/tracking/sagas';
import uiSagas from 'src/redux/ui/sagas';
import undoSagas from 'src/redux/undo/sagas';

export default function* sagas() {
  yield all([
    fork(appSagas),
    fork(initDesignProSagas),
    fork(jobDesignsSagas),
    fork(jobShareSagas),
    fork(keyboardEventsSagas),
    fork(macheteSagas),
    fork(measureModeSagas),
    fork(notificationSagas),
    fork(splitSagas),
    fork(trackingSagas),
    fork(uiSagas),
    fork(undoSagas),
  ]);
}
